// extracted by mini-css-extract-plugin
export var bubble = "_1c-0";
export var container = "_1c-f";
export var contrastBorder = "_1c-g";
export var greyOut = "_1c-2";
export var initialsColor0 = "_1c-3";
export var initialsColor1 = "_1c-4";
export var initialsColor10 = "_1c-d";
export var initialsColor11 = "_1c-e";
export var initialsColor2 = "_1c-5";
export var initialsColor3 = "_1c-6";
export var initialsColor4 = "_1c-7";
export var initialsColor5 = "_1c-8";
export var initialsColor6 = "_1c-9";
export var initialsColor7 = "_1c-a";
export var initialsColor8 = "_1c-b";
export var initialsColor9 = "_1c-c";
export var initialsWrapper = "_1c-1";
export var large = "_1c-l";
export var medium = "_1c-k";
export var mediumSmall = "_1c-j";
export var mediumSmallMedium = "_1c-o";
export var micro = "_1c-h";
export var small = "_1c-i";
export var tiny = "_1c-n";
export var xTiny = "_1c-m";